import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.payments.EditCounterpartyPaymentDetailsPopupContent.SecondStep', {
    paymentMethod: 'Payment method',
    entityType: 'Entity type',
    company: 'Company',
    individual: 'Individual',
    selectPlaceholder: 'Select...',
    confirmChanges: 'Confirm changes',
    confirmChangesDescription:
        'Are you sure you want to edit this? If you proceed, all existing details will be cleared.',
    confirm: 'Confirm',
});
